module.exports = __webpack_public_path__ + "static/media/color.3c5b0587.png";